module.exports = __webpack_public_path__ + "static/media/copy-line.da1259ec.svg";